export const fr = {
  title: `Les impacts sur les adultes`,
  psychosocial: `Psychosocial`,
  work: `Travail`,
  driving: `Conduite automobile`,
  sexuality: `Sexualité`,
  sleep: `Sommeil`,
  memory: `Mémoire`,
  sport: `Loisirs et activités physique`,
  entertaining: `Divertissements`,
  alcool: `Alcool`,
  lifeInsurance: `Assurance vie`,
  parenthood: `Parentalité`
};
